import { render, staticRenderFns } from "./CompGoFlexTopButtons.vue?vue&type=template&id=28d8dc4e"
import script from "./CompGoFlexTopButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGoFlexTopButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports